export default __webpack_public_path__ + "static/media/lockerroomlogo.ce54eb18.PNG";